import { getCenter } from 'ol/extent';
import { toLonLat } from 'ol/proj';

export const findGeoCenter = feature => toLonLat(getCenter(feature.getGeometry().getExtent()));
